import Vue from "vue";
const vm = new Vue()

export const showSuccessModal = msg => {
    vm.$bvModal.msgBoxOk(msg, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "ตกลง",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
    });
};

export const showErrorModal = msg => {
    vm.$bvModal.msgBoxOk(msg, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
    });    
};

export const showConfirmSuccessModal = msg => {
    vm.$bvModal.msgBoxOk(msg, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "Done",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
    })
    .then(value => {
        if (value) {
            window.location.reload();
        }
    });
};
                